import React, { CSSProperties, ReactNode, useEffect, useState } from "react";
import { HiChevronLeft } from "react-icons/hi";
import styled from "styled-components";
import useDragResize from "../useDragResize";
import useWindowSize from "./useWindowSize";

export const Container = styled.div`
  flex: 1;

  overflow: hidden;

  .hfcentered {
    flex: 1;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 768px) {
    flex: 1;
  }
`;

export const List = styled.ul<{ flex: number }>`
  display: flex;
  flex: ${(p) => p.flex};
  overflow: hidden;
  @media (min-width: 768px) {
    width: 10vh;
    min-width: 270px;
  }
`;

export const Content = styled.ul<{ flex: number }>`
  display: flex;
  flex: ${(p) => p.flex};
  overflow-y: auto;
`;

export const HorizontalResize = styled.span`
  position: relative;

  width: 5px;
  justify-content: center;

  cursor: ew-resize;

  border-left: 2px solid #ddd;
  color: #ddd;

  justify-content: center;
  align-items: center;

  margin-block: 0.5vh;

  span {
    position: absolute;
    right: -4px;
    height: 25px;
    background-color: white;
    align-items: center;
    justify-content: center;
  }

  :hover {
    border-left: 2px solid #888;
    color: #888;
  }

  transition:
    color 200ms,
    border 200ms;
`;

export const GoBack = styled.button`
  cursor: pointer;
  width: fit-content;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  :active {
    opacity: 0.5;
  }
`;

// import { Container } from './styles';

interface SideListViewProps {
  list: ReactNode;
  content: ReactNode;
  view: "LIST" | "CONTENT";
  onGoBack?: () => void;
  style?: CSSProperties;
  useBackButton?: boolean;
}

const SideListView: React.FC<SideListViewProps> = (props) => {
  const isSmall = useWindowSize();
  const [view, setView] = useState(props.view ?? "LIST");

  const { flex, handleDragStart, handleDrag, handleDragEnd } = useDragResize({
    initialFlex: 0.25,
    minFlex: 0.15,
    maxFlex: 0.5,
  });

  useEffect(() => {
    setView(props.view);
    //??
  }, [props.view]);

  useEffect(() => {
    const handlePopstate = (/*event: PopStateEvent*/) => {
      if (view === "CONTENT") {
        handleGoBack();
      }
    };

    window.addEventListener("popstate", handlePopstate);

    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, [view]);

  function handleGoBack() {
    if (props.onGoBack) {
      props.onGoBack();
      return;
    } else {
      setView("LIST");
    }
  }

  if (!isSmall) {
    return (
      <div
        style={props.style ?? undefined}
        className="flex flex-1 flex-row overflow-hidden"
      >
        <ul
          className={`flex overflow-hidden`}
          style={{ flex: flex, minWidth: "270px" }}
        >
          {props.list}
        </ul>
        <span
          className="relative my-1 flex w-[5px] cursor-ew-resize justify-center border-l-2 border-zinc-300 transition-colors duration-200 hover:border-zinc-600"
          draggable
          onDrag={handleDrag}
          onDragEnd={handleDragEnd}
          onDragStart={handleDragStart}
          onTouchStart={() => handleDragStart()}
          onTouchMove={handleDrag}
          onTouchEnd={handleDragEnd}
        >
          <span className="absolute right-[-4px] flex h-[25px] items-center justify-center bg-white" />
        </span>
        <ul className="flex flex-1 overflow-y-auto" style={{ flex: 1 - flex }}>
          {props.content}
        </ul>
      </div>
    );
  } else {
    return (
      <div
        style={props.style ?? undefined}
        className="flex flex-1 flex-col overflow-hidden"
      >
        {view === "LIST" ? (
          <ul className="flex flex-1 overflow-hidden">{props.list}</ul>
        ) : (
          <>
            {props.useBackButton === true && (
              <button
                className="flex w-fit cursor-pointer items-center justify-center bg-transparent active:opacity-50"
                onClick={handleGoBack}
              >
                <HiChevronLeft size={40} />
              </button>
            )}
            <ul className="flex flex-1 overflow-y-auto">{props.content}</ul>
          </>
        )}
      </div>
    );
  }
};

export default SideListView;
